import React, { useState, useEffect } from 'react';
import { EquipmentType } from '../enums';

// Create an array of objects containing both key and display value
const equipmentTypeOptions = Object.entries(EquipmentType).map(([key, value]) => ({
  key,
  displayValue: value
}));

interface EquipmentSelectorProps {
  onTypeChange: (selectedType: string) => void;
  onModelChange: (selectedModel: string | null) => void;
  models: string[];
  loading?: boolean;
}

export const EquipmentSelector: React.FC<EquipmentSelectorProps> = ({
  onTypeChange,
  onModelChange,
  models,
  loading = false
}) => {
  const [selectedType, setSelectedType] = useState<string>(''); // Set a default value
  const [selectedModel, setSelectedModel] = useState<string | null>(null);
    
  // Reset selected model when type changes
  useEffect(() => {
    setSelectedModel(null);
  }, [selectedType]);

  const handleTypeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newType = e.target.value;
    setSelectedType(newType);
    onTypeChange(newType);
  };

  const handleModelChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const newModel = e.target.value || null;
    setSelectedModel(newModel);
    onModelChange(newModel);
  };

  const handleReset = () => {
    setSelectedType('');
    setSelectedModel(null);
    onTypeChange('');
    onModelChange(null);
  };

  return (
    <div className="card mb-4">
      <div className="card-header bg-primary text-white">
        <h5 className="mb-0">Equipment Filter</h5>
      </div>
      <div className="card-body">
        <div className="row g-3">
          <div className="col-md-5">
            <label htmlFor="equipmentType" className="form-label">Equipment Type</label>
            <select 
              id="equipmentType" 
              className="form-select"
              value={selectedType || ''}
              onChange={handleTypeChange}
            >
              <option value="">All Equipment Types</option>
              {equipmentTypeOptions.map(({ key, displayValue }) => (
                <option key={key} value={key}>
                  {displayValue}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-5">
            <label htmlFor="equipmentModel" className="form-label">Model</label>
            <select 
              id="equipmentModel" 
              className="form-select"
              value={selectedModel || ''}
              onChange={handleModelChange}
              disabled={!selectedType}
            >
              <option value="">All Models</option>
              {models.map((model) => (
                <option key={model} value={model}>
                  {model}
                </option>
              ))}
            </select>
          </div>
          <div className="col-md-2 d-flex align-items-end">
            <button 
              className="btn btn-secondary w-100"
              onClick={handleReset}
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                  <span className="ms-2">Loading...</span>
                </>
              ) : 'Reset'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};